import unauthorizedRedirect from "~/components/utilities/unauthorizedRedirect";

const reviseForSubmitArticle = async function reviseForSubmitArticle() {
  try {
    await this.$store.dispatch("reviseSubmissionStatus", {
      params: {
        id: this.item.id,
        note: this.userNotes,
      },
    });
  } catch (error) {
    if (
      error.status &&
      error.status.find((err) => err.message === "Access Denied")
    ) {
      unauthorizedRedirect(
        this.$router.replace,
        this.$isServer,
        this.$config,
        undefined
      );
    } else {
      throw error;
    }
  }

  this.$root.$emit("change-view", {
    view: "administration-dashboard?show=new-submissions",
  });

  this.userNotes = "";
};

export default reviseForSubmitArticle;
